import { useEffect, useRef, DependencyList } from 'react';

export function useTimeout(callback: () => void, duration: number, deps: DependencyList = []) {
  /**
   * Store the callback in a ref so that we don't reset the timeout with
   * anonymous functions
   */
  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  /**
   * Create a timeoutId and cancel callback so that we can return this to the invoker
   */
  const timeoutId = useRef<NodeJS.Timeout | null>();

  const cancelTimeout = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
  };

  useEffect(() => {
    const handleTimeout = () => {
      savedCallback.current();
    };

    timeoutId.current = setTimeout(handleTimeout, duration);

    return () => {
      cancelTimeout();
    };
  }, [duration, ...deps]);

  return cancelTimeout;
}
